// removed by extract-text-webpack-plugin
module.exports = {"notificationsContainer":"_-src-components-NotificationStep-styles---notificationsContainer---2ti4i"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NotificationStep/styles.css
// module id = 776
// module chunks = 0